import React, { useEffect, useState } from 'react'
import avtar1 from '../../assets/images/user/avatar-1.jpg'
import { Link } from 'react-router-dom'
import { deleteData, getData, imgUrl, patchData, deleteDataNew } from '../Services/api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import Pagination from '../Services/Pagination'

const AdminList = () => {
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);

    const fetchUsers = async (pageNumber = page, searchQuery = search) => {
        try {
            const res = await getData(`/users/admin?page=${pageNumber}&search=${searchQuery}`);
            if (res.success) {
                setUsers(res.data || []);
                setPage(res.pagination.page || 1);
                setPages(res.pagination.totalPages || 1);  // ✅ Fixed: was pagination.pages
                setTotal(res.pagination.total || 0);
            }
        } catch (error) {
            console.log("error fetch users", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, search]);

    const handlePageChange = (pageNumber) => {
        if (pageNumber !== page) {
            setPage(pageNumber);  // ✅ Fixed: update page state
            fetchUsers(pageNumber);
        }
    };

    const handleDelete = (userId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/users/delete/${userId}`);
                    if (res.status) {
                        toast.success(res.message);
                        fetchUsers();
                    }
                } catch (error) {
                    console.log("error delete user", error)
                }
            }
        });
    }

    // ✅ Bulk delete
    const handleBulkDelete = () => {
        if (selectedUsers.length === 0) {
            toast.warn('Please select at least one user!');
            return;
        }

        Swal.fire({
            title: 'Delete selected users?',
            text: 'This will permanently remove selected users!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete all!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteDataNew('/users/delete-multiple', { ids: selectedUsers });
                    if (res.status) {
                        toast.success(res.message);
                        setSelectedUsers([]);
                        fetchUsers();
                    }
                } catch (error) {
                    console.log('error bulk delete', error);
                    toast.error('Error deleting selected users!');
                }
            }
        });
    };

    // ✅ Select handlers
    const handleSelectUser = (userId) => {
        setSelectedUsers((prev) =>
            prev.includes(userId)
                ? prev.filter((id) => id !== userId)
                : [...prev, userId]
        );
    };

    const handleSelectAll = () => {
        if (selectedUsers.length === users.length) {
            setSelectedUsers([]);
        } else {
            setSelectedUsers(users.map((u) => u.id));
        }
    };

    const handleStatusChange = async (userId, status) => {
        const newStatus = status === 'active' ? 'inactive' : 'active'
        try {
            const res = await patchData(`/users/toggle-status/${userId}`, { status: newStatus });
            if (res.status) {
                toast.success(res.message)
                fetchUsers();
            }
        } catch (error) {
            console.log("error status change", error)
        }
    }

    return (
        <div className="pc-container">
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/admin/admin-list">Admins</Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-12">
                                <div className="page-header-title">
                                    <h2 className="mb-0">Admins</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card table-card">
                            <div className="card-body">
                                <div className="d-sm-flex align-items-center p-4">
                                    <ul className="list-inline me-auto my-1">
                                        <li className="list-inline-item">
                                            <div className="form-search">
                                                <i className="fas fa-search" />
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    placeholder="Search user"
                                                    value={search}
                                                    onChange={(e) => {
                                                        setSearch(e.target.value);
                                                        setPage(1);
                                                    }}
                                                />
                                            </div>
                                        </li>
                                    </ul>
                                    {/* ✅ Fixed: Delete Selected button enabled */}
                                    <div className="text-end p-4 pb-sm-2">
                                        <button
                                            onClick={handleBulkDelete}
                                            className="btn btn-danger mx-2"
                                        >
                                            <i className="fas fa-trash mx-1" /> Delete Selected
                                        </button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-hover" id="pc-dt-simple">
                                        <thead>
                                            <tr>
                                                <th>
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={
                                                            users.length > 0 &&
                                                            selectedUsers.length === users.length
                                                        }
                                                    />
                                                </th>
                                                <th>S.No.</th>
                                                <th>Admin Details</th>
                                                <th>Admin Name</th>
                                                <th>Contact Number</th>
                                                <th>Company Name</th>
                                                <th>Role</th>
                                                <th>Status</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                users?.length > 0 ? (
                                                    users.map((user, index) => {
                                                        return (
                                                            <tr key={user.id}>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedUsers.includes(user.id)}
                                                                        onChange={() => handleSelectUser(user.id)}
                                                                    />
                                                                </td>
                                                                <td>{index + 1 + (page - 1) * 10}</td>
                                                                <td>
                                                                    <div className="row">
                                                                        <div className="col-auto">
                                                                            <img
                                                                                src={user?.profile_image ? `${imgUrl}${user.profile_image}` : avtar1}
                                                                                alt="user-image"
                                                                                className="wid-40 rounded-circle"
                                                                            />
                                                                        </div>
                                                                        <div className="col">
                                                                            <h6 className="mb-0">{user.username}</h6>
                                                                            <p className="text-muted f-12 mb-0">
                                                                                {user.email}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>{user.username}</td>
                                                                <td>{user.mobile}</td>
                                                                <td>{user.company_name}</td>
                                                                <td>{user?.role}</td>
                                                                <td>
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={user.status}
                                                                            onChange={() => handleStatusChange(user.id, user.status)}
                                                                            role="switch"
                                                                        />
                                                                    </div>
                                                                </td>
                                                                {/* ✅ Fixed: Actions column enabled with delete button */}
                                                                <td className="text-center">
                                                                    <ul className="list-inline me-auto mb-0">
                                                                        <li
                                                                            className="list-inline-item align-bottom"
                                                                            data-bs-toggle="tooltip"
                                                                            title="Delete"
                                                                        >
                                                                            <button
                                                                                onClick={() => handleDelete(user.id)}
                                                                                className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                            >
                                                                                <i className="fas fa-trash f-18" />
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td className='text-center' colSpan={9}><strong>No Users Found.</strong></td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                                    <div className="text-muted">
                                        Showing {total === 0 ? 0 : (page - 1) * 10 + 1} to {Math.min(page * 10, total)} of {total} entries
                                    </div>
                                    <Pagination
                                        page={page}
                                        pages={pages}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminList